<script setup lang="ts">
  import { computed, ref } from 'vue'

  const props = defineProps({
    collection: { type: Object, required: true }
  })
  const sectionLinesStore = useSectionLinesStore()
  const { loadingFieldNames, fieldNames, fetchGeometryFieldNames } = useShapeFileUpload()
  const polygonFile = ref(null)
  const uploading = ref(false)
  const zoneName = ref('')
  const zoneType = ref('')

  const onChangeFile = computed({
    get: () => polygonFile.value,
    set: (newValue) => {
      polygonFile.value = newValue
      fetchGeometryFieldNames([newValue])
    }
  })

  const uploadFile = async () => {
    uploading.value = true
    const formData = new FormData()
    formData.append('file', polygonFile.value)
    formData.append('zone_name', zoneName.value)
    formData.append('zone_type', zoneType.value)
    formData.append('sectionlineuploadcollection', props.collection.id)
    try {
      await sectionLinesStore.uploadPolygonShapeFile(formData)
      uploading.value = false
    } catch (error) {
      console.log(error)
      uploading.value = false
    }
  }
</script>

<template>
  <div class="pa-4">
    <v-file-input
      color="primary"
      v-model="onChangeFile"
      prepend-icon="mdi-folder-zip"
      class="mt-3"
      label="Upload .zip containing the polygon .shp file"
      accept=".zip"
      hide-details
    >
    </v-file-input>
    <v-row class="mt-2">
      <v-col cols="1"></v-col>
      <v-col>
        <v-select
          color="primary"
          class="mb-2"
          :loading="loadingFieldNames"
          :items="fieldNames"
          filled
          hint="This field is used to link the uploaded lines and polygon to each other."
          :persistent-hint="true"
          label="Select zone name"
          v-model="zoneName"
        >
        </v-select>
        <v-select
          class="mt-2"
          color="primary"
          :loading="loadingFieldNames"
          :items="fieldNames"
          filled
          hint="zone type"
          label="Select zone type"
          v-model="zoneType"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-card-actions class="justify-end">
      <v-btn
        variant="text"
        color="primary"
        @click="sectionLinesStore.toggleAddPolygonShapeFileDialog()"
      >
        Cancel
      </v-btn>
      <v-btn color="primary" :disabled="!polygonFile" :loading="uploading" @click="uploadFile">
        Upload
      </v-btn>
    </v-card-actions>
  </div>
</template>
